import { zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const FecImportModalOverlay = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--lumen-spacing-24);
  padding: var(--lumen-padding-24) var(--lumen-padding-32);
  position: fixed;
  inset: 0;
  z-index: ${zIndex.FullScreenOverlay};
  background-color: var(--lumen-color-surface-neutral-base);
  overflow: hidden;
`

export const FecImportModalStepper = styled.div`
  width: min(40rem, calc(100vw - 22rem));
`

interface FecImportModalBodyProps {
  $isContentCentered: boolean
}

export const FecImportModalBody = styled.div<FecImportModalBodyProps>`
  display: flex;
  align-items: ${({ $isContentCentered }) => ($isContentCentered ? 'center' : 'stretch')};
  flex: 1;
  flex-direction: column;
  justify-content: ${({ $isContentCentered }) => ($isContentCentered ? 'center' : 'flex-start')};
  min-height: 0;
  padding: var(--lumen-padding-24) var(--lumen-padding-32);
  border: var(--lumen-border-width-xs) solid var(--lumen-color-border-neutral-soft);
  border-radius: var(--lumen-border-radius-8);
  overflow: ${({ $isContentCentered }) => ($isContentCentered ? 'auto' : 'hidden')};
`
